import styled from 'styled-components';
import PhoneInputTheme
  from '@shipae/components-sandbox/component/phone-input/theme/neutral';
import CheckboxTheme
  from '@shipae/components-sandbox/component/checkbox/theme/shipa-delivery';

export const CustomPhoneInputTheme = {
  ...PhoneInputTheme,
  Main: styled(PhoneInputTheme.Main)`
    &:after {
      top: calc(5.6rem - 1px);
      bottom: unset;
      height: 1px;
    }
  `,
};

export const CustomCheckboxTheme = {
  ...CheckboxTheme,
  Main: styled(CheckboxTheme.Main)`
    height: auto;
  `,
};
